import React from 'react'
import { useDroppable } from '@dnd-kit/core'
import { ContainerProps } from './type'

export const Droppable = <T extends React.ElementType>(
    props: ContainerProps<T>
) => {
    const {
        as,
        id,
        data,
        style,
        className,
        children,
        isOverStyle,
        isOverClassName,
        ...rest
    } = props
    const Element = as

    const { isOver, setNodeRef } = useDroppable({
        id,
        data,
    })

    return (
        <Element
            ref={setNodeRef}
            style={{
                ...style,
                ...(isOver ? isOverStyle : {}),
            }}
            className={`${className} ${
                isOver ? isOverClassName : ''
            }`}
            {...rest}
        >
            {children}
        </Element>
    )
}
